<p-dialog
  [header]="'ABANDONED_CART.replaceCartHeader' | translate"
  [visible]="displayReplaceDialog()"
  (visibleChange)="displayReplaceDialog.set($event)"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '400px' }"
>
  <div>
    <p>{{ 'ABANDONED_CART.replaceCartMessage' | translate }}</p>
  </div>
  <ng-template #footer>
    <div class="flex justify-content-end w-full">
      <div>
        <app-button
          type="button"
          [label]="'ABANDONED_CART.replaceCartReject' | translate"
          buttonStyle="outlined"
          (handleClick)="rejectReplace()"
        ></app-button>
      </div>
      <div>
        <app-button
          type="button"
          [label]="'ABANDONED_CART.replaceCartAccept' | translate"
          (handleClick)="acceptReplace()"
        ></app-button>
      </div>
    </div>
  </ng-template>
</p-dialog>

@if (isLoading()) {
  <div class="abandoned-cart-recovery">
    <p-progressSpinner ariaLabel="loading" />
    <p>{{ 'ABANDONED_CART.recoveringCart' | translate }}</p>
  </div>
}
